export default __webpack_public_path__ + "static/media/tour.33b5fdad.svg";